<template>
  <div
    class="drop-area"
    :class="modifiers"
    @dragenter="ondragenter"
    @dragover="ondragover"
    @dragleave="ondragleave"
    @drop="ondrop"
    @click="$emit('click', $event)"
  >
    <slot />
  </div>
</template>

<script>
  export default {
    name: "DropArea",
    data() {
      return {
        modifiers: {
          highlight: false,
        }
      };
    },
    methods: {
      ondragenter(ev) {
        this.modifiers.highlight = true;
        this.$emit("dragenter", ev);
      },
      ondragover(ev) {
        this.modifiers.highlight = true;
        this.$emit("dragover", ev);
      },
      ondragleave(ev) {
        this.modifiers.highlight = false;
        this.$emit("dragleave", ev);
      },
      ondrop(ev) {
        this.modifiers.highlight = false;
        this.$emit("drop", ev);
      }
    }
  }
</script>